/*
 * @Author: youthscc(蒋松)
 * @Date: 2024-06-21 14:37:30
 * @LastEditors: youthscc(蒋松)
 * @LastEditTime: 2024-06-24 15:44:58
 * @Description: 定位原生调用方法优化升级版
 */
import { trace } from '../trace'
import { $t } from '../i18n'

class Location_harmony {
  getAddress(callback) {
    console.log('鸿蒙定位开始')
    trace.log('location-msg', {
      from: 'harmony',
      msg: '开始定位: getAddress'
    })
    window.$zhm.getPermissionAndLocationInfo((res) => {
      const data = JSON.parse(res)
      console.log('鸿蒙定位返回成功', data)
      if (data.code !== 0) {
        let msgErr = data.msg || $t('mei-you-quan-xian')
        trace.log('location-msg', {
          from: 'harmony',
          msg: '没有定位权限 -99: getAddress',
          data: data
        })
        callback({
          code: '-99',
          msg: msgErr
        })
        return
      } else {
        console.log('鸿蒙定位返回成功222222', {
          code: 0,
          province: data.province,
          city: data.city || data.district,
          district: data.district,
          lon: data.lon,
          lat: data.lat,
          street: data.street,
          address: data.address,
          isTransformed: true // 是否精确,为ture,gcoord.transform不需要纠正了; 百度地图已经精准定位,所以不需要纠正了;
        })
        callback({
          code: 0,
          province: data.province,
          city: data.city || data.district,
          district: data.district,
          lon: data.lon,
          lat: data.lat,
          street: data.street,
          address: data.address,
          isTransformed: true // 是否精确,为ture,gcoord.transform不需要纠正了; 百度地图已经精准定位,所以不需要纠正了;
        })
      }
    })
  }
}
export default Location_harmony
